import { Component, OnInit, Input } from '@angular/core';
import { Ticket } from './ticket';
import { ActivatedRoute } from '@angular/router';
import { TicketService } from './ticketService';
import { UserService } from '../_services';
import { User } from '../user/user';
import { Authenticate } from '../authenticate/authenticate';
import { Machine } from '../machine/machine';
import { Client } from '../client/client';


@Component({
  selector: 'app-ticket',
  templateUrl: './ticket.component.html',
  styleUrls: ['./ticket.component.less', '../app.component.less']
})
export class TicketComponent implements OnInit {

  //#region Local Variables

  // Input properties to receive machine and client data from parent components
  @Input() machineI: Machine;
  @Input() inClient: Client;

  // Sorting variables
  sortColumn: string = '';
  sortDirection: string = 'asc';
  sortedTickets: any[] = [];

  // List of tickets and the currently selected ticket
  tickets: Ticket[];
  ticket = new Ticket();

  // User and authentication details
  currentuser: User;
  auth: Authenticate;
  private userrole: string;
  isAdmin = false;

  // Search and filter criteria
  _selectedstatusid: number = 1;
  querycriteria: string;
  searchquery: string;
  jwt: string;
  ticketCount: number = 0;

  // Pagination variables
  p: Number = 1;
  count: Number = 10;

  // Visibility toggles for ticket details
  showTicketId = true;
  showClient = true;
  showMachine = true;
  showTitle = true;
  showPostedBy = true;
  showDateOfTicket = true;
  showStatus = true;
  showDetails = true;

  // Currently selected client
  _currentclient: Client = new Client();

  //#endregion

  // Inject services into the constructor for API communication and route handling
  constructor(
    private ticketservice: TicketService,
    private userservice: UserService,
    private activateroute: ActivatedRoute,
  ) { }

  // Lifecycle hook: Runs when the component initializes
  ngOnInit() {
    // Get the currently logged-in user
    this.currentuser = this.userservice.getCurrentUserFromCookie();
    this.userrole = this.currentuser.role.name;

    // Get the ticket ID from the route parameters
    const id = +this.activateroute.snapshot.paramMap.get('id');

    // Check if the user has administrative privileges
    if (this.userrole === "Authenticated" || this.userrole === "Administrator") {
      this.isAdmin = true;
      
      // Fetch all tickets if no specific client ID is provided
      if (id === 0) {
        this.ticketservice.getTicketsQl().subscribe(response => {
          this.tickets = response.reverse(); // Reverse to show latest tickets first
          this.ticketCount = this.tickets.length;
        });
      } 
      // Fetch tickets for a specific client
      else if (id > 0) {
        this.ticketservice.getClientTickets(id).subscribe(response => {
          this.tickets = response.reverse();
          this.ticketCount = this.tickets.length;
        });
      }
    } 
    // If the user is a client, fetch only their tickets
    else {
      if (this.userrole === "clientsrole") {
        this.ticketservice.getClientTickets(this.currentuser.client.id).subscribe(res => {
          this.tickets = res.reverse();
        });
      }
    }
  }

  // Fetch a specific ticket by its ID
  getTicketById(id: number) {
    this.ticketservice.getTicket(id).subscribe(ticket => this.ticket = ticket);
  }

  // Search for tickets based on a given argument (e.g., client name, ticket ID)
  search(argument) {
    if (this.userrole === "Authenticated" || this.userrole === "Administrator") {
      if (this.querycriteria === 'client') {
        // If the user is an admin, fetch all client tickets
        this.ticketservice.getTicketsByClientNameQl(this.querycriteria, argument).subscribe(res => {
          this.tickets = res.reverse();
          this.ticketCount = this.tickets.length;
          this._currentclient = res[0]?.client; // Assign the first client's details if available
        });
      } 
      // If the user is a client, fetch only their tickets
      else {
        this._currentclient = null;
        this.ticketservice.getTicketsByCriteriaQl(this.querycriteria, argument).subscribe(res => {
          this.tickets = res.reverse();
          this.ticketCount = this.tickets.length;
        });
      }
    }
  }

  // Sort tickets based on the selected column
  sortData(column: string) {
    if (this.sortColumn === column) {
      this.sortDirection = this.sortDirection === 'asc' ? 'desc' : 'asc';
    } else {
      this.sortColumn = column;
      this.sortDirection = 'asc';
    }
    this.sortTickets();
  }

  // Function to sort the tickets array dynamically based on the selected column
  sortTickets() {
    this.tickets = this.tickets.sort((a, b) => {
      const aValue = this.getValue(a, this.sortColumn);
      const bValue = this.getValue(b, this.sortColumn);

      if (aValue < bValue) {
        return this.sortDirection === 'asc' ? -1 : 1;
      } else if (aValue > bValue) {
        return this.sortDirection === 'asc' ? 1 : -1;
      } else {
        return 0;
      }
    });
  }

  // Helper function to access nested properties dynamically
  getValue(ticket: any, column: string): any {
    const keys = column.split('.');
    let value = ticket;
    for (const key of keys) {
      if (value) {
        value = value[key];
      }
    }
    return value;
  }
}
